import request from "../utils/request";

export function modifyKeyword(keyword) {
    return request({
        url: '/api/keyword/index',
        method: 'post',
        data: keyword
    })
}

export function getKeywords() {
    return request({
        url: '/api/keyword/',
    })
}

export function deleteKeywords(id){
    return request({
        url: '/api/com/delete',
        params: {
            table: 'sys_keyword',
            id: id
        }
    })
}